<template>
  <div>
    <div class="sga-page-11 page-11">
      <h3>Additional Information</h3>
      <p>
        <strong
          >What is your desired company culture? <br />
          Your responses can be added to your resume or hidden in the resume
          area: your choice!</strong
        ><br />
        <!-- <strong>How would you describe your desired company's culture? - Don’t worry, giving us this information won’t identify you – the answers to these questions will remain anonymous</strong><br/> -->
      </p>
      <el-form @submit.native.prevent>
        <label role="text">
          Please select six...
        </label>
        <el-form-item
          :error="
            retrieveFieldError(modelState, 'Culture.selectedCultureOptions')
          "
          :required="true"
        >
          <el-checkbox-group
            v-model="sgaCulture.selectedCultureOptions"
            class="ts-form--cbgroup"
          >
            <el-checkbox label="Challenging" border
              ><v-icon
                name="regular/grin-alt"
                scale="1.2"
              />Challenging</el-checkbox
            >
            <el-checkbox label="Rewarding" border
              ><v-icon
                name="regular/grin-hearts"
                scale="1.2"
              />Rewarding</el-checkbox
            >
            <el-checkbox label="Flexible" border
              ><v-icon
                name="regular/grin-stars"
                scale="1.2"
              />Flexible</el-checkbox
            >
            <el-checkbox label="Supportive" border
              ><v-icon
                name="regular/laugh"
                scale="1.2"
              />Supportive</el-checkbox
            >
            <el-checkbox label="Powerful Leadership" border
              ><v-icon name="regular/smile-beam" scale="1.2" />Powerful
              Leadership</el-checkbox
            >
            <el-checkbox label="Exciting" border
              ><v-icon
                name="regular/laugh-squint"
                scale="1.2"
              />Exciting</el-checkbox
            >
            <el-checkbox label="Stressful" border
              ><v-icon
                name="regular/meh-rolling-eyes"
                scale="1.2"
              />Stressful</el-checkbox
            >
            <el-checkbox label="Caring" border
              ><v-icon
                name="regular/kiss-wink-heart"
                scale="1.2"
              />Caring</el-checkbox
            >
            <el-checkbox label="Busy" border
              ><v-icon
                name="regular/grin-beam-sweat"
                scale="1.2"
              />Busy</el-checkbox
            >
            <el-checkbox label="Staff Focused" border
              ><v-icon name="chalkboard-teacher" scale="1.2" />Staff
              Focused</el-checkbox
            >
            <el-checkbox label="Innovative" border
              ><v-icon
                name="regular/lightbulb"
                scale="1.2"
              />Innovative</el-checkbox
            >
            <el-checkbox label="Strong Teams" border
              ><v-icon name="users" scale="1.2" />Strong Teams</el-checkbox
            >
            <el-checkbox label="Motivating" border
              ><v-icon name="bolt" scale="1.2" />Motivating</el-checkbox
            >
            <el-checkbox label="Unstructured" border
              ><v-icon name="band-aid" scale="1.2" />Unstructured</el-checkbox
            >
            <el-checkbox label="Driven By Compliance" border
              ><v-icon name="pencil-ruler" scale="1.2" />Driven By
              Compliance</el-checkbox
            >
            <el-checkbox label="Positive" border
              ><v-icon name="user-plus" scale="1.2" />Positive</el-checkbox
            >
            <el-checkbox label="Cooperative" border
              ><v-icon
                name="regular/object-group"
                scale="1.2"
              />Cooperative</el-checkbox
            >
            <el-checkbox label="Risk Taking" border
              ><v-icon name="user-ninja" scale="1.2" />Risk Taking</el-checkbox
            >
            <el-checkbox label="Fair" border
              ><v-icon name="balance-scale" scale="1.2" />Fair</el-checkbox
            >
            <el-checkbox label="Task Focused" border
              ><v-icon name="globe" scale="1.2" />Task Focused</el-checkbox
            >
            <el-checkbox label="Low Levels Of Management Monitoring" border
              ><v-icon name="regular/surprise" scale="1.2" />Low Levels of
              Management/Monitoring</el-checkbox
            >
            <el-checkbox label="Adaptable" border
              ><v-icon name="exchange-alt" scale="1.2" />Adaptable</el-checkbox
            >
            <el-checkbox label="Results Orientated" border
              ><v-icon name="search-dollar" scale="1.2" />Results
              Orientated</el-checkbox
            >
            <el-checkbox label="Lacks Accountability" border
              ><v-icon name="regular/tired" scale="1.2" />Lacks
              Accountability</el-checkbox
            >
            <el-checkbox label="Decisive" border
              ><v-icon name="directions" scale="1.2" />Decisive</el-checkbox
            >
            <el-checkbox label="Goal Orientated" border
              ><v-icon name="trophy" scale="1.2" />Goal Orientated</el-checkbox
            >
            <el-checkbox label="Lacks Communication" border
              ><v-icon name="regular/meh-blank" scale="1.2" />Lacks
              Communication</el-checkbox
            >
            <el-checkbox label="Field Experts" border
              ><v-icon name="brain" scale="1.2" />Field Experts</el-checkbox
            >
            <el-checkbox label="Admit Mistakes" border
              ><v-icon name="regular/grimace" scale="1.2" />Admit
              Mistakes</el-checkbox
            >
            <el-checkbox label="Achievers" border
              ><v-icon name="regular/star" scale="1.2" />Achievers</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-alert
          v-if="hasErrorInCulture"
          title="Please select 6 items."
          type="error"
          show-icon
        ></el-alert>
        <label role="text">Kindly select what is your work set-up.</label>
        <el-form-item
          :error="retrieveFieldError(modelState, 'culture.workSetup')"
          :required="true"
        >

          <el-radio-group  v-model="sgaCulture.workSetup">
            <div class="">
              <el-radio label="Remote">100% remote</el-radio>
              <el-radio label="Travel">Travel</el-radio>
              <el-radio label="Remote-Travel">Remote and Travel</el-radio>
            </div>
          </el-radio-group>          
        </el-form-item>
        <el-alert
          v-if="hasErrorInWorkSetup"
          title="Please select your work setup."
          type="error"
          show-icon
        ></el-alert>

        <div v-if="sgaCulture.workSetup != 'Remote'">
          <label role="text"
            >What is the distance of your roundtrip commute to work?</label
          >
          <el-form-item
            :error="retrieveFieldError(modelState, 'culture.commuteDistance')"
            :required="true"
          >
            <el-select
              v-model="sgaCulture.commuteDistance"
              placeholder="Please select a distance"
            >
              <el-option label="Less than 10 miles" value="10"></el-option>
              <el-option label="Less than 25 miles" value="25"></el-option>
              <el-option label="Less than 50 miles" value="50"></el-option>
              <el-option label="Less than 75 miles" value="75"></el-option>
              <el-option label="Less than 100 miles" value="100"></el-option>
              <el-option
                label="More than or equal to 100 miles"
                value="101"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-alert
            v-if="hasErrorInCommuteDistance"
            title="Please select your commute distance."
            type="error"
            show-icon
          ></el-alert>

          <label role="text"
            >Do you or would you utilize a personal vehicle, rideshare,
            ride-hailing (Uber, Lyft, taxi, etc.), public transportation, walk or
            bicycle to & from work.</label
          >
          <el-form-item
            :error="retrieveFieldError(modelState, 'culture.transportation')"
            :required="true"
          >
            <el-checkbox-group
              v-model="sgaCulture.transportation"
              class="ts-form--cbgroup"
            >
              <div class="ts-comp--multiselect-item">
                <el-checkbox label="Personal">Personal</el-checkbox>
              </div>
              <div class="ts-comp--multiselect-item">
                <el-checkbox label="Rideshare">Rideshare</el-checkbox>
              </div>
              <div class="ts-comp--multiselect-item">
                <el-checkbox label="Ride-Hailing">Ride-Hailing</el-checkbox>
              </div>
              <div class="ts-comp--multiselect-item">
                <el-checkbox label="Public Transport"
                  >Public Transport</el-checkbox
                >
              </div>
              <div class="ts-comp--multiselect-item">
                <el-checkbox label="Walk/Bicycle">Walk/Bicycle</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-alert
            v-if="hasErrorInTransportation"
            title="Please select at least 1 item."
            type="error"
            show-icon
          ></el-alert>
        </div>
        
        <button
          class="ts-btn ts-btn-rounded ts-btn-secondary"
          @click="storeSection()"
        >
          Continue
        </button>
        <a class="back-link" href="/sga/questionnaire/9">
          <i class="fas fa-chevron-left"></i>Back
        </a>
      </el-form>
    </div>
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      :page12="page12"
      currentPage="page12"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Image="Base64Raw" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV>  -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="DisplayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    TSLoading,
    ResumeListSelection
  },
  created() {
    this.$store.dispatch("sga/getsga").then(res => {
      if (this.currentSga.sgaEmployeeInfo != null) {
        this.sgaEmployeeInfo = this.currentSga.sgaEmployeeInfo;
      }
      if (this.currentSga.culture != null) {
        this.sgaCulture = this.currentSga.culture;
      }
    });

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  data() {
    return {
      Base64Raw: null,
      showResumeListModal: false,
      isLoading: false,
      modelState: {},      
      hasErrorInCulture: false,
      hasErrorInWorkSetup: false,
      hasErrorInCommuteDistance: false,
      hasErrorInTransportation: false,      
      sgaEmployeeInfo: {},
      sgaYourJob: {
        jobRole: {},
        jobDescriptionTasks: [],
        customTasks: []
      },
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          BachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaTechnologies: {
        selectedTechnologies: [],
        customTechnologies: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        workSetup: "",
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      showProfile: true,
      base64Raw: null,
      profile: {},
      profileSettings: []
    };
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2;
        } else {
          return {
            sgaYourJob: this.sgaYourJob,
            taskSearch: this.taskSearch,
            hiddenTasks: this.hiddenTasks
          };
        }
      } else {
        return {
          sgaYourJob: this.sgaYourJob,
          taskSearch: this.taskSearch,
          hiddenTasks: this.hiddenTasks
        };
      }
    },
    page3() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3;
        } else {
          return { sgaEducation: this.sgaEducation };
        }
      } else {
        return { sgaEducation: this.sgaEducation };
      }
    },
    page4() {
      this.sgaWorkHistory.userWorkHistory.forEach(element => {
        if (element.workedFrom == "0001-01-01T00:00:00") {
          element.workedFrom = null;
        }
        if (element.workedTo == "0001-01-01T00:00:00") {
          element.workedTo = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4;
        } else {
          return { sgaWorkHistory: this.sgaWorkHistory };
        }
      } else {
        return { sgaWorkHistory: this.sgaWorkHistory };
      }
    },
    page5() {
      this.sgaCertifications.userCertifications.forEach(element => {
        if (element.acquiredDt == "0001-01-01T00:00:00") {
          element.acquiredDt = null;
        }
        if (element.expirationDt == "0001-01-01T00:00:00") {
          element.expirationDt = null;
        }
        if (element.image == undefined) {
          element.image = null;
        }
      });

      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5;
        } else {
          return {
            sgaCertifications: this.sgaCertifications,
            selectedCodeDetail: this.selectedCodeDetail
          };
        }
      } else {
        return {
          sgaCertifications: this.sgaCertifications,
          selectedCodeDetail: this.selectedCodeDetail
        };
      }
    },
    page6() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page6) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page6;
        } else {
          return { sgaHiddenExtras: this.sgaHiddenExtras };
        }
      } else {
        return { sgaHiddenExtras: this.sgaHiddenExtras };
      }
    },
    page7() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page7) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page7;
        } else {
          return { sgaKnowledge: this.sgaKnowledge };
        }
      } else {
        return { sgaKnowledge: this.sgaKnowledge };
      }
    },
    page8() {
      return { 
        sgaTechnologies: this.sgaTechnologies 
      };
    },
    page9() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page9) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page9;
        } else {
          return { sgaMindset: this.sgaMindset };
        }
      } else {
        return { sgaMindset: this.sgaMindset };
      }
    },
    page10() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page10) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page10;
        } else {
          return { sgaSkills: this.sgaSkills };
        }
      } else {
        return { sgaSkills: this.sgaSkills };
      }
    },
    page11() {
      if (sessionStorage.getItem("sgaDataForPrinting")) {
        if (JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page11) {
          return JSON.parse(sessionStorage.getItem("sgaDataForPrinting"))
            .page11;
        } else {
          return { sgaHiddenTalents: this.sgaHiddenTalents };
        }
      } else {
        return { sgaHiddenTalents: this.sgaHiddenTalents };
      }
    },
    page12() {
      return {
        sgaCulture: this.sgaCulture
      };
    }
  },
  methods: {
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    DisplayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store
        .dispatch("account/getprofiledetails", obj)
        .then(res => {
          this.profile = res;
          this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
          this.closeResumeListModal();

          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        })
        .catch(res => {
          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        });
    },
    storeSection() {
      this.isLoading = true;
      this.currentSga.sgaEmployeeInfo = this.sgaEmployeeInfo;
      this.currentSga.culture = {};
      this.currentSga.culture.selectedCultureOptions = this.sgaCulture.selectedCultureOptions;
      this.currentSga.culture.workSetup = this.sgaCulture.workSetup;
      this.currentSga.culture.commuteDistance = this.sgaCulture.commuteDistance;
      this.currentSga.culture.transportation = this.sgaCulture.transportation;
      this.currentSga.culture.id = this.sgaCulture.id;

      if (this.currentSga.culture.selectedCultureOptions.length === 6 
        && this.currentSga.culture.workSetup == "Remote") {
          this.currentSga.culture.commuteDistance = "";
          this.currentSga.culture.transportation = [];
        this.saveSga();
      } else if(this.currentSga.culture.selectedCultureOptions.length === 6
        && (this.currentSga.culture.workSetup != "" && this.currentSga.culture.workSetup != undefined)
        && this.currentSga.culture.commuteDistance != ""
        && this.currentSga.culture.transportation.length != 0) {
          this.saveSga();
      } else {               
        this.hasErrorInCulture = false;
        this.hasErrorInWorkSetup = false;
        this.hasErrorInCommuteDistance = false; 
        this.hasErrorInTransportation = false;

        if (this.currentSga.culture.selectedCultureOptions.length !== 6)
        {
          this.hasErrorInCulture = true;
        }

        if (this.currentSga.culture.workSetup === "" || this.currentSga.culture.workSetup == undefined)
        {
          this.hasErrorInWorkSetup = true;
        } else {
          if (this.currentSga.culture.workSetup != "Remote") {
            if (this.currentSga.culture.commuteDistance == "") {
              this.hasErrorInCulture = true;
            }

            if (this.currentSga.culture.transportation.length === 0) {
              this.hasErrorInTransportation = true;
            }
          }
        }
        this.isLoading = false; 
      }

      sessionStorage.setItem(
        "sgaDataForPrinting",
        JSON.stringify({
          page1: this.page1,
          page2: this.page2,
          page3: this.page3,
          page4: this.page4,
          page5: this.page5,
          page6: this.page6,
          page7: this.page7,
          page8: this.page8,
          page9: this.page9,
          page10: this.page10,
          page11: { sgaCulture: this.currentSga.culture, isComplete: true }
        })
      );
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;

        this.$store
          .dispatch("sga/getSGAforPrint", this.currentSga.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    },
    saveSga() {
      this.currentSga.culture.isComplete = true;
        if (this.currentSga.culture.id == null) {
          this.$store
            .dispatch("sga/postsga", this.currentSga)
            .then(() => {
              this.$router.app.$emit("navigateToNextStep");
            })
            .catch(res => {
              this.modelState = res.errors;
              this.isLoading = false;
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else {
          this.$store
            .dispatch("sga/putsga", this.currentSga)
            .then(() => {
              this.$router.app.$emit("navigateToNextStep");
            })
            .catch(res => {              
              this.modelState = res.errors;
              this.isLoading = false;
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
    }
  }
};
</script>

<style lang="scss"></style>
